// extracted by mini-css-extract-plugin
module.exports = {"header":"e_-n","gallery":"e_ao","label":"e_bo"};